import { Call, Email } from "@mui/icons-material";
import { Stack, TextField, Typography } from "@mui/material";
import { User } from "../../../../types/User";
import { getNullableString } from "../../../../util/string";

interface ContactInfoProps {
    userData: User;
    handleChange: (field: string, value: any) => void;
    editMode: boolean;
}

const ContactInfo = ({ userData, handleChange, editMode }: ContactInfoProps) => {
    return (
        <>
            <Typography variant="subtitle1" mb={2}>
                Contact Information
            </Typography>

            <Stack spacing={1}>
                <Stack direction="row" alignItems="center" gap={2}>
                    {editMode ? (
                        <TextField
                            fullWidth
                            size="small"
                            label="Email"
                            value={userData.email || ""}
                            onChange={(e) => handleChange("email", e.target.value)}
                            disabled={true} // Email usually can't be changed directly
                        />
                    ) : (
                        <Stack direction="row" alignItems="center" gap={2}>
                            <Email sx={{ color: "text.secondary", fontSize: 20 }} />
                            <Typography variant="body1" fontWeight={400}>
                                {userData.email || "No email provided yet."}
                            </Typography>
                        </Stack>
                    )}
                </Stack>
                <Stack direction="row" alignItems="center" gap={2}>
                    {editMode ? (
                        <TextField
                            fullWidth
                            size="small"
                            label="Phone"
                            value={userData.phone || ""}
                            onChange={(e) => handleChange("phone", e.target.value)}
                        />
                    ) : (
                        <Stack direction="row" alignItems="center" gap={2}>
                            <Call sx={{ color: "text.secondary", fontSize: 20 }} />
                            <Typography variant="body1" fontWeight={400}>
                                {getNullableString(userData.phone)}
                            </Typography>
                        </Stack>
                    )}
                </Stack>
            </Stack>
        </>
    );
};

export default ContactInfo; 